import React from 'react';
import Page from './components/Page';
import UserDetails from './pageparts/UserDetails';
import Builders from './pageparts/Builders';

const MainPage = ()=>{
	return <Page>
		<UserDetails />
		<Builders />
	</Page>
}

export default MainPage;